export default __webpack_public_path__ + "static/media/app.1171199f.svg";